import axios from '@/axiosConnection'
import toastr from '@/toastr'

export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getAll: state => state.items,
  },
  actions: {
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'tag',
        api_data_path: 'tags',
        namespace: 'tag'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/tag.js